import React, { useEffect, useState } from 'react';
import { AppDispatch, IReduxState } from 'app/store';
import { useDispatch, useSelector } from 'react-redux';
import {
  setCancelDownloadId,
  resetDownloads,
  removeNewDownloads,
  updateDownloadFiles,
  addIntervalsDownloading,
  removeIntervalDownloading
} from '../../../features/DownloadsSlice';
import CircularProgress from '@mui/material/CircularProgress';
import { IconArrow } from 'common/components/Icons/IconArrow/IconArrow';
import { Button, Text } from '@cyberpion/cyberpion-ui';
import { Collapse, Grow } from '@mui/material';
import { PopUp } from 'common/components/popUp/PopUp';
import Tooltip from '@mui/material/Tooltip';
import { RestApi } from 'common/services/rest-api.service';

import './Downloads.scss';

const cancelIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g clip-path="url(#clip0_12421_9767)">
      <path
        d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
        fill="#EAEAEA"
      />
      <path d="M5.99988 10.0005L10.0002 6.00016" stroke="#5D6576" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M10.0001 10.0005L5.9998 6.00016" stroke="#5D6576" stroke-linecap="round" stroke-linejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_12421_9767">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
const csvIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="3.69231" fill="white" />
    <path
      d="M6 10.5988V4.03055C6 3.4614 6.46139 3 7.03055 3H15.0591L20 7.90903V20.2987C20 20.3908 19.9817 20.482 19.9463 20.5671C19.9108 20.6522 19.8588 20.7295 19.7933 20.7946C19.7277 20.8597 19.6499 20.9114 19.5643 20.9466C19.4786 20.9819 19.3868 21 19.2942 21H6.70584C6.51864 21 6.33911 20.9261 6.20674 20.7946C6.07437 20.6631 6 20.4847 6 20.2987V16.9104"
      stroke="#5D6576"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M15 3V8H20" stroke="#5D6576" stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M16.8467 9.66895H3.65327C3.48022 9.66968 3.31446 9.74323 3.1921 9.87357C3.06974 10.0039 3.00069 10.1805 3 10.3648V17.3041C3 17.4887 3.06883 17.6657 3.19134 17.7962C3.31385 17.9267 3.48001 18 3.65327 18H16.8467C17.02 18 17.1861 17.9267 17.3087 17.7962C17.4312 17.6657 17.5 17.4887 17.5 17.3041V10.3648C17.4993 10.1805 17.4303 10.0039 17.3079 9.87357C17.1855 9.74323 17.0198 9.66968 16.8467 9.66895Z"
      fill="#1AA884"
    />
    <path
      d="M8.14697 13.3794H6.70801V12.4155C6.70801 12.1353 6.69206 11.9609 6.66016 11.8926C6.63053 11.8219 6.56331 11.7866 6.4585 11.7866C6.34001 11.7866 6.26481 11.8288 6.23291 11.9131C6.20101 11.9974 6.18506 12.1797 6.18506 12.46V15.0303C6.18506 15.2992 6.20101 15.4746 6.23291 15.5566C6.26481 15.6387 6.33659 15.6797 6.44824 15.6797C6.55534 15.6797 6.62484 15.6387 6.65674 15.5566C6.69092 15.4746 6.70801 15.2821 6.70801 14.979V14.2852H8.14697V14.5005C8.14697 15.0724 8.10596 15.478 8.02393 15.7173C7.94417 15.9565 7.7653 16.1662 7.4873 16.3462C7.21159 16.5262 6.87093 16.6162 6.46533 16.6162C6.04378 16.6162 5.69629 16.5399 5.42285 16.3872C5.14941 16.2345 4.96826 16.0238 4.87939 15.7549C4.79053 15.4837 4.74609 15.077 4.74609 14.5347V12.918C4.74609 12.5192 4.75977 12.2207 4.78711 12.0225C4.81445 11.8219 4.89535 11.6294 5.02979 11.4448C5.1665 11.2603 5.35449 11.1156 5.59375 11.0107C5.83529 10.9036 6.11214 10.8501 6.42432 10.8501C6.84814 10.8501 7.19792 10.9321 7.47363 11.0962C7.74935 11.2603 7.9305 11.4653 8.01709 11.7114C8.10368 11.9552 8.14697 12.3358 8.14697 12.853V13.3794ZM11.7119 12.6411H10.3755V12.231C10.3755 12.0396 10.3584 11.9176 10.3242 11.8652C10.29 11.8128 10.2331 11.7866 10.1533 11.7866C10.0667 11.7866 10.0007 11.8219 9.95508 11.8926C9.91178 11.9632 9.89014 12.0703 9.89014 12.2139C9.89014 12.3984 9.9152 12.5374 9.96533 12.6309C10.0132 12.7243 10.1488 12.8371 10.3721 12.9692C11.0124 13.3498 11.4157 13.6619 11.582 13.9058C11.7484 14.1496 11.8315 14.5426 11.8315 15.085C11.8315 15.4792 11.7848 15.7697 11.6914 15.9565C11.6003 16.1434 11.4225 16.3006 11.1582 16.4282C10.8939 16.5535 10.5863 16.6162 10.2354 16.6162C9.85026 16.6162 9.521 16.5433 9.24756 16.3975C8.9764 16.2516 8.79867 16.0659 8.71436 15.8403C8.63005 15.6147 8.58789 15.2946 8.58789 14.8799V14.5176H9.92432V15.1909C9.92432 15.3983 9.94255 15.5316 9.979 15.5908C10.0177 15.6501 10.085 15.6797 10.1807 15.6797C10.2764 15.6797 10.347 15.6421 10.3926 15.5669C10.4404 15.4917 10.4644 15.38 10.4644 15.2319C10.4644 14.9061 10.4199 14.693 10.3311 14.5928C10.2399 14.4925 10.0155 14.325 9.65771 14.0903C9.29997 13.8534 9.06299 13.6813 8.94678 13.5742C8.83057 13.4671 8.73372 13.319 8.65625 13.1299C8.58105 12.9408 8.54346 12.6992 8.54346 12.4053C8.54346 11.9814 8.59701 11.6715 8.7041 11.4756C8.81348 11.2796 8.98893 11.127 9.23047 11.0176C9.47201 10.9059 9.76367 10.8501 10.1055 10.8501C10.4792 10.8501 10.797 10.9105 11.0591 11.0312C11.3234 11.152 11.4977 11.3047 11.582 11.4893C11.6686 11.6715 11.7119 11.9826 11.7119 12.4224V12.6411ZM15.7041 10.9663L14.9727 16.5H12.7886L11.958 10.9663H13.4756C13.651 12.4907 13.7764 13.7793 13.8516 14.832C13.9268 13.7679 14.0054 12.8223 14.0874 11.9951L14.1865 10.9663H15.7041Z"
      fill="white"
    />
  </svg>
);

const successIcon = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_12452_11828)">
      <path
        d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
        fill="#1AA884"
      />
      <path
        d="M10.4848 6.3999L6.88484 9.9999L5.24847 8.36354"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_12452_11828">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const errorIcon = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_12452_11835)">
      <path
        d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
        fill="#F46666"
      />
      <path d="M8 9L8 5" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M8 11.5L8 11" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_12452_11835">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export function Downloads() {
  const [isOpen, setIsOpen] = useState(true);
  const [showCancelIconId, setShowCancelIconId] = useState<string | null>(null);
  const [showCancelAllPopup, setShowCancelAllPopup] = useState(false);
  const [downloadedFiles, setDownloadedFiles] = useState<any>([]);
  const { downloadFilesData, newDownloads, visible, intervalsDownloading } = useSelector(
    (state: IReduxState) => state.downloads
  );
  const { user } = useSelector((state: any) => state.login);
  const dispatch: AppDispatch = useDispatch();

  const handleClose = () => {
    const inProgress = Object.keys(downloadFilesData).find((item: any) => {
      return downloadFilesData[item].status.toLowerCase() === 'in progress';
    });
    if (!!inProgress) {
      setShowCancelAllPopup(true);
    } else {
      dispatch(resetDownloads());
    }
  };

  useEffect(() => {
    return () => {
      dispatch(resetDownloads());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!!Object.keys(intervalsDownloading).length && !!Object.keys(downloadFilesData).length) {
      Object.keys(downloadFilesData).forEach((item: any) => {
        if (
          (downloadFilesData[item].status.toLowerCase() === 'completed successfully' ||
            downloadFilesData[item].status.toLowerCase() === 'failed') &&
          !!intervalsDownloading[item]
        ) {
          clearInterval(intervalsDownloading[item]);
        }
      });
      Object.keys(downloadFilesData).forEach((item: any) => {
        if (
          (downloadFilesData[item].status.toLowerCase() === 'completed successfully' ||
            downloadFilesData[item].status.toLowerCase() === 'failed') &&
          !!intervalsDownloading[item]
        ) {
          dispatch(removeIntervalDownloading(item));
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [intervalsDownloading, downloadFilesData]);

  useEffect(() => {
    if (!!Object.keys(downloadFilesData).length) {
      Object.keys(downloadFilesData).forEach((item: any) => {
        if (
          downloadFilesData[item].status.toLowerCase() === 'completed successfully' &&
          !!downloadFilesData[item].info?.temp_download_link &&
          !downloadedFiles.includes(item)
        ) {
          let link: any = document.createElement('a');
          link.style.display = 'none';
          document.body.appendChild(link);
          link.download = downloadFilesData[item].file_name;
          link.id = downloadFilesData[item].file_name;
          link.href = downloadFilesData[item].info?.temp_download_link;
          link.click();
          document.body.removeChild(link);

          setDownloadedFiles([...downloadedFiles, item]);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downloadFilesData]);

  const downloadFile = (file: any) => () => {
    let link: any = document.createElement('a');
    link.style.display = 'none';
    document.body.appendChild(link);
    link.download = file.file_name;
    link.id = file.file_name;
    link.href = file.info?.temp_download_link;
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    if (!!newDownloads.length) {
      const account = window.location.href.includes('pages/accounts') ? `?account=${user.company_name}` : '';
      newDownloads.forEach((item: any) => {
        const url = `reports/csv/${item}/${account}`;
        RestApi.getData(url).subscribe((response: any) => {
          dispatch(updateDownloadFiles(response));
        });
        const interval = setInterval(() => {
          RestApi.getData(url).subscribe((response: any) => {
            dispatch(updateDownloadFiles(response));
          });
        }, 5000);
        newDownloads.forEach((item: any) => {
          dispatch(removeNewDownloads(item));
        });
        dispatch(addIntervalsDownloading({ id: item, interval: interval }));
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newDownloads]);

  const handleMouseEnter = (id: string) => () => {
    setShowCancelIconId(id);
  };

  const handleMouseLeave = () => {
    setShowCancelIconId(null);
  };

  const handleOnCancel = (id: number) => () => {
    dispatch(setCancelDownloadId(id));
    setShowCancelIconId(null);
    if (!!intervalsDownloading[id]) {
      clearInterval(intervalsDownloading[id]);
      dispatch(removeIntervalDownloading(id));
    }
  };

  const handleCancelAllDownloads = () => {
    dispatch(resetDownloads());
    setShowCancelAllPopup(false);
  };

  return (
    <div>
      {!!visible && !!Object.keys(downloadFilesData).length ? (
        <Grow in={visible}>
          <div className="Downloads">
            <div className="downloads-header" style={isOpen ? { paddingBottom: 12 } : {}}>
              {!!Object.keys(downloadFilesData).filter(
                (item: string) => downloadFilesData[item].status.toLowerCase() === 'in progress'
              ).length ? (
                <Text textSize={15} weight={500}>
                  {`Downloading ${
                    Object.keys(downloadFilesData).filter(
                      (item: string) => downloadFilesData[item].status.toLowerCase() === 'in progress'
                    ).length
                  } documents`}
                </Text>
              ) : (
                <Text textSize={15} weight={500}>
                  Downloading completed
                </Text>
              )}
              <div className="downloads-header-actions">
                <div onClick={() => setIsOpen(!isOpen)} className="chevron-icon">
                  <IconArrow toggleRotate={!isOpen} />
                </div>
                <div className="devider" />
                <img src="/assets/images/x.svg" className="close-trigger" onClick={handleClose} alt="Close" />
              </div>
            </div>
            <Collapse in={isOpen} timeout="auto" unmountOnExit sx={{ width: '100%' }}>
              <Text textSize={13} style={{ marginBottom: 8 }}>
                Closing the window will cancel all downloads
              </Text>
              <div className="scrollbar-common">
                <div className="downloads-list-wrapper">
                  <div className="downloads-list">
                    {Object.keys(downloadFilesData).map((item: any, index: number) => {
                      const file = downloadFilesData[item];
                      const isProgress =
                        (showCancelIconId === null || showCancelIconId !== file?.id) &&
                        file.status.toLowerCase() === 'in progress';
                      const isCancel =
                        file.status.toLowerCase() !== 'completed successfully' &&
                        file.status.toLowerCase() !== 'failed' &&
                        showCancelIconId !== null &&
                        showCancelIconId === file?.id &&
                        file.status.toLowerCase() !== 'canceled';
                      const isSuccess = file.status.toLowerCase() === 'completed successfully';
                      const isCanceled = file.status.toLowerCase() === 'canceled';

                      return (
                        <div
                          className="download-item"
                          style={index !== downloadFilesData.length - 1 ? { borderBottom: '1px solid #EAEAEA' } : {}}
                          onMouseEnter={handleMouseEnter(file?.id)}
                          onMouseLeave={handleMouseLeave}
                        >
                          <div className="icon">{csvIcon}</div>
                          <Tooltip
                            title={<Text textColor="#FFF">{file?.file_name || 'Csv file'}</Text>}
                            placement="top-start"
                            componentsProps={{
                              tooltip: {
                                sx: {
                                  bgcolor: '#4D4C53',
                                  color: '#FFFFFF',
                                  padding: '3px 6px',
                                  marginBottom: '0px !important',
                                  '& .MuiTooltip-arrow': {
                                    color: '#4D4C53'
                                  },
                                  border: '1px solid black',
                                  borderRadius: 1
                                }
                              }
                            }}
                          >
                            <div>
                              <Text
                                textSize={13}
                                style={{
                                  marginLeft: 8,
                                  flexGrow: 1,
                                  width: !isCanceled ? 330 : 310,
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis'
                                }}
                              >
                                {file?.file_name || 'Csv file'}
                              </Text>
                            </div>
                          </Tooltip>

                          {isProgress && (
                            <div className="loading-item">
                              {/* <AppLoading size="small" /> */}
                              <div className="download-progress-wrapper">
                                <CircularProgress size={26} variant="determinate" value={file.completed_percent} />
                                <div className="download-progress-text">
                                  <Text textSize={9} textColor="#6E6D7B">
                                    {`${Math.round(file.completed_percent)}%`}
                                  </Text>
                                </div>
                              </div>
                            </div>
                          )}
                          {isCancel && (
                            <Tooltip
                              title={<Text textColor="#FFF">Cancel download</Text>}
                              placement="top-start"
                              componentsProps={{
                                tooltip: {
                                  sx: {
                                    bgcolor: '#4D4C53',
                                    color: '#FFFFFF',
                                    padding: '3px 6px',
                                    marginBottom: '0px !important',
                                    '& .MuiTooltip-arrow': {
                                      color: '#4D4C53'
                                    },
                                    border: '1px solid black',
                                    borderRadius: 1
                                  }
                                }
                              }}
                            >
                              <div className="cancel-download-item" onClick={handleOnCancel(file.id)}>
                                {cancelIcon}
                              </div>
                            </Tooltip>
                          )}
                          {isCanceled && (
                            <Text textSize={13} textColor="#6E6D7B" style={{ marginRight: 15, marginLeft: 10 }}>
                              Canceled
                            </Text>
                          )}
                          {isSuccess && (
                            <Tooltip
                              title={<Text textColor="#FFF">Download file</Text>}
                              placement="top-start"
                              componentsProps={{
                                tooltip: {
                                  sx: {
                                    bgcolor: '#4D4C53',
                                    color: '#FFFFFF',
                                    padding: '3px 6px',
                                    marginBottom: '0px !important',
                                    '& .MuiTooltip-arrow': {
                                      color: '#4D4C53'
                                    },
                                    border: '1px solid black',
                                    borderRadius: 1
                                  }
                                }
                              }}
                            >
                              <div className="cancel-download-item" onClick={downloadFile(file)}>
                                {successIcon}
                              </div>
                            </Tooltip>
                          )}
                          {file.status.toLowerCase() === 'failed' && (
                            <div className="success-download-item">{errorIcon}</div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
        </Grow>
      ) : null}
      {!!showCancelAllPopup && (
        <PopUp visible={showCancelAllPopup} setVisible={() => setShowCancelAllPopup}>
          <div className="download-cancel-all">
            <div className="cancel-header">
              <Text textSize={20} weight={500}>
                Cancel al downloads?
              </Text>
              <img
                src="/assets/images/x.svg"
                className="close-trigger"
                onClick={() => setShowCancelAllPopup(false)}
                alt="Close"
              />
            </div>
            <div className="cancel-content">
              <Text textSize={14} textColor="#5D6576">
                Your downloads are not complete. Would you like to cancel all ongoing downloads?
              </Text>
            </div>
            <div className="cancel-footer">
              <Button
                text="Continue Downloads"
                onClick={() => setShowCancelAllPopup(false)}
                type="button"
                buttonStyle="main"
                size={'medium'}
                className="cancel-footer-button"
              />
              <Button
                text="Cancel Downloads"
                onClick={handleCancelAllDownloads}
                type="button"
                buttonStyle="secondary"
                size={'medium'}
                className="cancel-footer-button"
              />
            </div>
          </div>
        </PopUp>
      )}
    </div>
  );
}
